import type { State } from '../index'
import { useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import { Button, Modal, Space, message } from 'antd'
import { DeleteOutlined, EditOutlined, ExportOutlined, ImportOutlined, PlusOutlined, SyncOutlined } from '@ant-design/icons'
import { FormPage, EasyModal, TemplateImport } from 'src/components'
import Create from './Create'
import { layoutStore } from 'enasops/stores'
import { $api, $consts } from 'src/plugins'
import { getTemplateConfig, downloadTemplate } from 'src/components/base/helper'

const tempCode = 'D005'

const Header = observer(() => {
  const state: State = layoutStore.slotData.state

  const tempConfig = useRef<any>()
  useEffect(() => {
    getTemplateConfig(tempCode).then((res: any) => {
      res?.IsSuccessful && (tempConfig.current = res.Data)
    })
  }, [])

  const handleExport = () => {
    if (!tempConfig.current?.Nav_ImportConfig) {
      message.error('获取配置失败')
      return
    }

    downloadTemplate({
      ...tempConfig.current.Nav_ImportConfig,
      IsData: true
    })
  }

  const handleDel = () => {
    const { active } = state
    Modal.confirm({
      title: `确认删除【${active!.Name}】行业？`,
      onOk: () => {
        $api['op140/delete']({ ID: active!.Id }).then(res => {
          if (res) {
            state.getIndustry(true)
            message.success('删除成功')
          }
        })
      }
    })
  }

  const { active } = state
  const disable = !active?.Id || active.Type === $consts['COMMON/INDUSTRY_TYPE_BASE'] // 基础库不能删除
  const record = { ID: active?.Id, CODE: active?.Code, NAME: active?.Name }
  return (
    <Space>
      <EasyModal
        modal={{ title: '版本管理', width: 700 }}
        slot={<Button type='primary' icon={<SyncOutlined />}>版本</Button>}
      >
        {/** 此 formId 后端无用，也不对应具体表单，只是用于前端调用编辑表单时，能走获取表单详情的流程 */}
        <FormPage formCode='OP142' formData={{ formId: 'bdb8c899-2d81-11c5-cd9e-99e0fde28c11' }} />
      </EasyModal>
      <EasyModal
        modal={{ title: '新增领域行业', width: 380 }}
        slot={<Button type='primary' icon={<PlusOutlined />}>新增行业</Button>}
      >
        <Create />
      </EasyModal>
      <EasyModal
        fullModal
        modal={{ title: '导入Excel数据' }}
        slot={<Button type='primary' icon={<ImportOutlined />}>导入</Button>}
      >
        <TemplateImport formCode={tempCode} />
      </EasyModal>
      <Button type='primary' icon={<ExportOutlined />} onClick={handleExport}>导出</Button>
      <EasyModal
        modal={{ title: '编辑', width: 380 }}
        slot={<Button ghost type='primary' icon={<EditOutlined />}>编辑</Button>}
      >
        <Create record={record} />
      </EasyModal>
      <Button
        ghost
        danger
        type='primary'
        disabled={disable}
        icon={<DeleteOutlined />}
        onClick={handleDel}
      >删除</Button>
    </Space>
  )
})

export default Header